import { useSubMenu } from '../../SubMenuContext';
import { twMerge } from 'tailwind-merge';

const SidebarMenu = ({ children }: { children: React.ReactNode }) => {
	const { isSidebarOpen, isContentOpen, sideWidth = 280 } = useSubMenu();

	return (
		<div className={twMerge(`h-[calc(100%-45px)] !transition-none bg-white rounded-tr-xl rounded-tl-xl`, `${isContentOpen ? '' : 'rounded-tr-xl'}`)}>
			<div className='!px-[6.5px] !py-5 !pt-3 justify-between flex flex-col gap-1 h-full transition-[width] duration-200' style={{ width: isSidebarOpen ? sideWidth : 50 }}>
				{children}
			</div>
		</div>
	);
};

export default SidebarMenu;
